document.addEventListener('DOMContentLoaded', () => {

  let allProducts = [];

  // Fetch all products (first 250)
  fetch('/products.json?limit=250')
    .then(res => res.json())
    .then(data => {
      allProducts = data.products;
      addProductImages();
    })
    .catch(err => console.error('Error fetching Shopify products:', err));

  function addProductImages() {
    const rows = document.querySelectorAll('.Evey__Premium__EventListTemplate__EventInfo__Container');

    rows.forEach(row => {
      // Skip if image already exists
      if (row.querySelector('.Evey__Premium__EventListTemplate__EventImage__Container')) return;

      const titleEl = row.querySelector('.Evey__Premium__EventList__EventTitle');
      if (!titleEl) return;

      const eventTitle = titleEl.textContent.trim();

      // Find matching product by title
      const product = allProducts.find(p => p.title.trim() === eventTitle);
      if (!product) return;

      // Grab the first image src
      const imgUrl = (product.images && product.images.length > 0)
        ? product.images[0].src
        : '/path/to/default-image.jpg'; // fallback

      // Create image container
      const imgContainer = document.createElement('div');
      imgContainer.className = 'Evey__Premium__EventListTemplate__EventImage__Container';

      const img = document.createElement('img');
      img.src = imgUrl;
      img.alt = eventTitle;
      img.style.width = '100px';
      img.style.height = '100px';
      img.style.objectFit = 'cover';
      img.style.borderRadius = '5px';

      imgContainer.appendChild(img);

      // Insert image between date/time and details
      const detailsDiv = row.querySelector('.Evey__Premium__EventListTemplate__EventDetails__Container');
      if (detailsDiv) row.insertBefore(imgContainer, detailsDiv);
    });
  }

  // Observe dynamically added rows
  const observer = new MutationObserver(() => addProductImages());
  observer.observe(document.body, { childList: true, subtree: true });

});